<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Floating Panel (Popover)
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <ng-container *ngIf="isBrowser; else notBrowserTemplate">
    <h2>Customized Simple Floating Panel</h2>
    <div class="content__tools-wrap">
      <div class="content__row">
        <label for="placement" class="content__row-label">placement</label>
        <select [(ngModel)]="selectedPlacement" class="c-input-group__control" id="placement">
          <ng-container *ngFor="let placement of placements">
            <option [value]="placement">{{ placement }}</option>
          </ng-container>
        </select>
        <label for="language" class="content__row-label">language</label>
        <select [(ngModel)]="selectedLanguage" class="c-input-group__control" id="language">
          <ng-container *ngFor="let language of languages">
            <option [value]="language">{{ language }}</option>
          </ng-container>
        </select>

        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
      </div>
      <div class="content__row">
        <div class="c-input-check-inline">
          <input id="inlineCheckbox1" class="c-input-check-inline__input" type="checkbox" name="hasCloseButton"
            [(ngModel)]="hasCloseButton">
          <label for="inlineCheckbox1" class="c-input-check-inline__label">Has CloseButton</label>
        </div>
        <div class="c-input-check-inline">
          <input id="inlineCheckbox2" class="c-input-check-inline__input" type="checkbox" name="hasBackdrop"
            [(ngModel)]="hasBackdrop">
          <label for="inlineCheckbox2" class="c-input-check-inline__label">Has Backdrop</label>
        </div>
        <div class="c-input-check-inline">
          <input id="inlineCheckbox3" class="c-input-check-inline__input" type="checkbox" name="hasCaret"
            [(ngModel)]="hasCaret">
          <label for="inlineCheckbox3" class="c-input-check-inline__label">Has Caret</label>
        </div>
      </div>    
    </div>
    <ng-container *ngIf="selectedUseCase === 'SimpleFloatingPanel'">
      <maced-floating-panel id="floatingpanel1" [placement]="selectedPlacement" [hasCloseButton]="hasCloseButton"
      [hasBackdrop]="hasBackdrop" [hasCaret]="hasCaret" (closeFloatingPanelEvent)="buttonFocus('SimplePanelId')" roleAttribute="alert">
      <ng-container ngProjectAs="[floatingPanelTarget]">
        <a href="javascript:void(0)" aria-haspopup="true" class="u-button u-button--link" id="SimplePanelId">
          Simple Floating Panel
        </a>
      </ng-container>
      <ng-container ngProjectAs="[floatingPanelBody]">
        <div class="c-floating-panel__body c-floating-panel__body--medium">
          <div class="content-block">
            <span *ngIf="selectedLanguage === 'English'">Content goes here</span>
            <span *ngIf="selectedLanguage === 'Spanish'">El contenido va aquí</span>
            <span *ngIf="selectedLanguage === 'Hindi'">विवरण यहाँ जाता है</span>
          </div>
        </div>
      </ng-container>
    </maced-floating-panel>
    </ng-container>


    <div class="u-position-relative u-mb-20" *ngIf="selectedUseCase === 'PenTool'">
      <div class="u-position-relative u-mb-20">
        <h2>Pen Tool</h2>
        <div *ngIf="penStroke">Selected Pen stroke Size: {{ penStroke }}</div>
        <div *ngIf="penColor">Selected Pen Color: {{ penColor }}</div>
      </div>
      <maced-floating-panel id="floatingpanel2" (closeFloatingPanelEvent)="buttonFocus('penToolId')" roleAttribute="alert">
        <ng-container ngProjectAs="[floatingPanelTarget]">
          <a href="javascript:void(0)" class="u-button u-button--link" id="penToolId">
            Floating Panel with Pen Tool
          </a>
        </ng-container>
        <ng-container ngProjectAs="[floatingPanelBody]">
          <div class="c-floating-panel__body c-floating-panel__body--medium">
            <maced-tool-pen [colorList]="colorList" [penTypeSize]="penTypeSize" [selectedPenSize]="penStroke"
              [selectedPenColor]="penColor" (penSize)="onPenSizeSelection($event)"
              (penColor)="onPenColorSelection($event)">
            </maced-tool-pen>
          </div>
        </ng-container>
      </maced-floating-panel>
    </div>

    <div class="u-position-relative u-mb-20" *ngIf="selectedUseCase === 'HighlightTool'">
      <div class="u-position-relative u-mb-20">
        <h2>Highlight Tool</h2>
        <div *ngIf="highlightStroke">Selected Highlight stroke Size: {{highlightStroke}}</div>
        <div *ngIf="highlightColor">Selected Highlight Color: {{highlightColor}}</div>
      </div>
      <maced-floating-panel id="floatingpanel3" (closeFloatingPanelEvent)="buttonFocus('highlightToolId')">
        <ng-container ngProjectAs="[floatingPanelTarget]" roleAttribute="alert">
          <a href="javascript:void(0)" class="u-button u-button--link" id="highlightToolId">
            Floating Panel with Highlight Tool
          </a>
        </ng-container>
        <ng-container ngProjectAs="[floatingPanelBody]">
          <div class="c-floating-panel__body c-floating-panel__body--medium">
            <maced-tool-highlight [colorList]="highlightColorList" [highlightStrokeSize]="highlightStrokeSize"
              [selectedHighlightSize]="highlightStroke" [selectedHighlightColor]="highlightColor"
              (highlightSize)="onHighlightSelection($event)" (highlightColor)="onHighlightColorSelection($event)">
            </maced-tool-highlight>
          </div>
        </ng-container>
      </maced-floating-panel>
    </div>

    <div class="u-position-relative u-mb-20" *ngIf="selectedUseCase === 'TypeTool'">
      <div class="u-position-relative u-mb-20">
        <h2>Type Tool</h2>
        <div *ngIf="textFontValue">Selected Type Font Size: {{textFontValue}}</div>
        <div *ngIf="textColor">Selected Text Color: {{textColor}}</div>
        <div *ngIf="textBackgroundColor">Selected Text Background Color: {{textBackgroundColor}}</div>
      </div>
      <maced-floating-panel id="floatingpanel4" (closeFloatingPanelEvent)="buttonFocus('toolTypeId')">
        <ng-container ngProjectAs="[floatingPanelTarget]" roleAttribute="alert">
          <a href="javascript:void(0)" class="u-button u-button--link" id="toolTypeId">
            Floating Panel with Type Tool
          </a>
        </ng-container>
        <ng-container ngProjectAs="[floatingPanelBody]" >
          <div class="c-floating-panel__body c-floating-panel__body--medium">
            <maced-tool-type [typeToolList]="typeToolList" [textFontSize]="textFontSize"
              [selectedFontSize]="textFontValue" [selectedTextColor]="textColor"
              [selectedBackgroundColor]="textBackgroundColor" (textFontValue)="ontextFontSelection($event)"
              (textColorValue)="onTextColorSelection($event)"
              (textBackgroundColorValue)="onTextBackgroundSelection($event)">
            </maced-tool-type>
          </div>
        </ng-container>
      </maced-floating-panel>
    </div>
    <div *ngIf="selectedUseCase === 'PopoverListWithZeroPadding'">
      <h2>Popover with list with zero Padding</h2>
      <div class="u-display-flex u-justify-content-center">
        <maced-floating-panel id="floatingpanel5" [placement]="selectedPlacement" [hasCaret]="hasCaret" roleAttribute="alert"
          [hasCloseButton]='hasCloseButton' [hasFooter]="true" [buttonList]="buttonList" (closeFloatingPanelEvent)="buttonFocus('buttonId22')">
          <ng-container ngProjectAs="[floatingPanelTarget]">
            <div class="c-floating-panel__button">
              <maced-button buttonId="buttonId22" color="secondary" ariaLabel="More" icon="icon-dots-vertical"
                position="right" label="More">
              </maced-button>
            </div>
          </ng-container>
          <ng-container ngProjectAs="[floatingPanelBody]">
            <div class="c-floating-panel__list">
              <maced-list-group listGroupId="listGroupId1">
                <maced-list listId="listId11" label="Label 11" ariaLabel="Label 11" url="/">
                </maced-list>
                <maced-list listId="listId12" label="Label 12" ariaLabel="Label 12" url="/">
                </maced-list>
              </maced-list-group>
            </div>
          </ng-container>
        </maced-floating-panel>
      </div>
    </div>
    <div *ngIf="selectedUseCase === 'PopoverListWith16pxPaddingWithScrollbar'">
      <h2>Popover with list with 16px Padding with scrollbar</h2>
      <div class="u-display-flex u-justify-content-center">
        <maced-floating-panel id="floatingpanel6" [placement]="selectedPlacement" [hasCaret]="hasCaret"
          [hasCloseButton]='hasCloseButton' (closeFloatingPanelEvent)="buttonFocus('buttonId23')" roleAttribute="alert">
          <ng-container ngProjectAs="[floatingPanelTarget]">
            <div class="c-floating-panel__button">
              <maced-button buttonId="buttonId23" color="secondary" ariaLabel="More" icon="icon-dots-vertical"
                position="right" label="More">
              </maced-button>
            </div>
          </ng-container>
          <ng-container ngProjectAs="[floatingPanelBody]">
            <div class="c-floating-panel__body c-floating-panel__body--medium">
              <div class="c-floating-panel__list">
                <maced-list-group listGroupId="listGroupId2">
                  <maced-list listId="listId21" label="Label 21" ariaLabel="Label 21" url="/">
                  </maced-list>
                  <maced-list listId="listId22" label="Label 22" ariaLabel="Label 22" url="/">
                  </maced-list>
                </maced-list-group>
              </div>
            </div>
          </ng-container>
        </maced-floating-panel>
      </div>
    </div>
    <div *ngIf="selectedUseCase === 'PopoverListWith24pxPadding'">
      <h2>Popover with list with 24px Padding</h2>
      <div class="u-display-flex u-justify-content-center">
        <maced-floating-panel id="floatingpanel7" [placement]="selectedPlacement" [hasCaret]="hasCaret"
          [hasCloseButton]='hasCloseButton' (closeFloatingPanelEvent)="buttonFocus('buttonId24')" roleAttribute="alert">
          <ng-container ngProjectAs="[floatingPanelTarget]">
            <div class="c-floating-panel__button">
              <maced-button buttonId="buttonId24" color="secondary" ariaLabel="More" icon="icon-dots-vertical"
                position="right" label="More">
              </maced-button>
            </div>
          </ng-container>
          <ng-container ngProjectAs="[floatingPanelBody]">
            <div class="c-floating-panel__body c-floating-panel__body--large">
              <div class="c-floating-panel__list">
                <maced-list-group listGroupId="listGroupId3">
                  <maced-list listId="listId31" label="Label 31" ariaLabel="Label 31" url="/">
                  </maced-list>
                  <maced-list listId="listId32" label="Label 32" ariaLabel="Label 32" url="/">
                  </maced-list>
                </maced-list-group>
              </div>
            </div>
          </ng-container>
        </maced-floating-panel>
      </div>
    </div>
  </ng-container>
  <ng-template #notBrowserTemplate>
    <form action="/floating-panel" method="get">
      <maced-dropdown-without-label id="dropdownId3" [dropdownOptions]="dropdownOptions"
        placeholderLabel="Select Language" name="language" [value]="inputNgModelNojs" roleAttribute="alert">
      </maced-dropdown-without-label>
      <maced-button buttonId="submit3" label="Submit" buttonType="submit"></maced-button>
      <div>
        <h4>Result</h4>
        <div>
          Input value:-&nbsp;
          {{ inputNgModelNojs }}
        </div>
      </div>
    </form>
  </ng-template>
</div>